import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";

export const ProductCard = ({ product }) => (
  <article
    data-testid={`product-card-${product.slug}`}
    className="card-vido h-full flex flex-col overflow-hidden fade-in"
  >
    <div className="aspect-[16/10] overflow-hidden bg-[hsl(var(--surface))]">
      <img
        src={product.image}
        alt={`${product.name} – ${product.category} från Vido Klimatteknik`}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-500 hover:scale-[1.03]"
      />
    </div>
    <div className="flex flex-col flex-1 p-5 md:p-6">
      <span
        className="eyebrow text-[color:hsl(var(--accent-terracotta))]"
        data-testid={`product-category-${product.slug}`}
      >
        {product.category}
      </span>
      <h3
        className="mt-3 text-xl md:text-[22px] font-serif font-medium leading-tight"
        data-testid={`product-name-${product.slug}`}
      >
        {product.name}
      </h3>
      <p className="mt-3 text-sm text-[color:hsl(var(--muted-ink))] leading-relaxed">
        {product.shortDescription}
      </p>
      <ul className="mt-4 space-y-1.5">
        {product.benefits.map((b) => (
          <li
            key={b}
            className="flex items-start gap-2 text-sm text-[color:hsl(var(--ink))]"
          >
            <Check
              size={16}
              className="mt-0.5 flex-shrink-0 text-[color:hsl(var(--accent-terracotta))]"
            />
            <span>{b}</span>
          </li>
        ))}
      </ul>
      <div className="mt-5 pt-5 border-t border-[color:hsl(var(--line))] flex items-end justify-between gap-4">
        <div className="min-w-0">
          {product.priceType === "från" && (
            <span className="text-xs text-[color:hsl(var(--muted-ink))] block">
              Från
            </span>
          )}
          <div
            className="text-2xl md:text-[28px] font-serif font-medium text-[color:hsl(var(--ink))] leading-none"
            data-testid={`product-price-${product.slug}`}
          >
            {product.price}
          </div>
          <div className="text-xs text-[color:hsl(var(--muted-ink))] mt-1">
            {product.priceNote}
          </div>
        </div>
        <Link
          to={`/produkter#${product.slug}`}
          data-testid={`product-see-more-${product.slug}`}
          className="inline-flex items-center gap-1 text-sm font-medium text-[color:hsl(var(--ink))] hover:text-[color:hsl(var(--accent-terracotta))] transition-colors"
        >
          Se mer
          <ArrowUpRight size={16} />
        </Link>
      </div>
    </div>
  </article>
);

export default ProductCard;
